export const isNullOrWhiteSpace = (value) => {
  if (value === null) { return true }

  if (typeof (value) !== 'string') { return false }

  return value.match(/^\s*$/)
}

export const urlifyString = (value) => {
  return value.toLowerCase().replace(/[^a-zA-Z ]/g, '').replace(/ /g, '-')
}

const valueToBoolean = (value) => {
  if (typeof value === 'boolean') {
    return value
  } 
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }
  return false
}

export const checkTypeNotCompletedValue = (type, value) => {
  switch (type.toLowerCase()) {
    case 'BIT':
    case 'boolean':
      return valueToBoolean(value)
    default:
      return !!value
  }
}
